import { render, staticRenderFns } from "./allSubscription.vue?vue&type=template&id=2ab03d2e&scoped=true"
import script from "./allSubscription.vue?vue&type=script&lang=js"
export * from "./allSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab03d2e",
  null
  
)

export default component.exports